import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center gap-1 h-5 px-1.5 text-2xs font-medium rounded-sm border tracking-wide',
  {
    variants: {
      variant: {
        default: 'bg-bg-muted text-fg-muted border-border',
        primary: 'bg-primary-soft text-primary border-primary/30',
        destructive: 'bg-destructive-soft text-destructive border-destructive/30',
        warning: 'bg-warning-soft text-warning border-warning/30',
        success: 'bg-success-soft text-success border-success/30',
        info: 'bg-info-soft text-info border-info/30',
        twitch: 'bg-platform-twitch-soft text-platform-twitch border-platform-twitch/30',
        youtube: 'bg-platform-youtube-soft text-platform-youtube border-platform-youtube/30',
        outline: 'bg-transparent text-fg-muted border-border',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
